import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static values = {
    keyPrefix: String,
  };

  connect() {
    this.storageKey = `${this.keyPrefixValue}Height`;

    this.setHeight();

    const resizeObserver = new ResizeObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.contentRect.height) {
          this.setValue(entry.contentRect.height);
        }
      });
    });

    resizeObserver.observe(this.element);
  }

  setHeight() {
    const height = this.getValue();

    if (height) {
      this.element.style.height = `${height}px`;
    }
  }

  getValue() {
    return localStorage.getItem(this.storageKey);
  }

  setValue(value) {
    localStorage.setItem(this.storageKey, value);
  }
}
